<template>
  <div>
    <form @submit.prevent="submit">
      <fields />
      <div v-if="model.zone" attribute="zone-linked" class="form-group row">
        <label for="zone-linked" class="col-sm-4 col-form-label text-sm-right"></label>
        <div class="col-sm-8">
          <div v-if="id" class="mt-3">
            <div class="card-field-wr mb-2">
              <i class="icon-exclamation text-info text-lg"></i>
              <span class="ml-1">{{ $t('airports.recreate_zone_hint') }}</span>
            </div>
            <template v-if="model.zone">
              <p class="mb-0">
                <span class="text-muted">{{ $t('airports.linked_zone') }}:</span>
                {{ model.zone.name }}
                <span class="text-muted">(#{{ model.zone.id }})</span>
                <router-link :to="{ name: 'zones', query: { query: model.zone.name, division_id: model.division_id } }" class="ml-2">
                  {{ $t('zones.zones') }}
                </router-link>
              </p>
            </template>
            <b-button
              v-else
              type="button"
              variant="outline-secondary"
              :disabled="recreateZoneLoading"
              @click="recreateAirportZone"
            >
              {{ $t('airports.recreate_zone') }}
            </b-button>
          </div>
        </div>
      </div>

      <div>
        <b-button type="submit" variant="primary">
          {{ $t('general.save') }}
        </b-button>
        <b-button type="button" variant="light" class="ml-2" @click="cancel">
          {{ $t('general.cancel') }}
        </b-button>

        <b-button
          v-b-modal="`airport-companies`"
          type="button"
          class="ml-2 float-right"
        >
          {{ $t('airports.auto_assign') }}
        </b-button>
      </div>
    </form>
    <template v-if="id">
      <companies :airport-id="id" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ResourceFormMixin } from 'stylemix-vue-admin'
import AirportsApi from './Api'
import Companies from './companies/Companies'

export default {
  name: 'AirportForm',
  components: { Companies },
  mixins: [ResourceFormMixin],

  data() {
    return {
      base: 'airports',
      formLoaded: false,
      recreateZoneLoading: false,
    }
  },

  computed: {
    ...mapState('zones', ['currentDivision']),
  },

  watch: {
    currentDivision: {
      handler(newVal) {
        if (newVal && !this.formLoaded) {
          this.formLoaded = true
          this.loadForm()
        }
      },
      immediate: true,
    },
  },

  methods: {
    api() {
      return new AirportsApi().setParameters({
        division_id: this.currentDivision?.id,
      })
    },

    submit() {
      this.save().then(() => {
        this.$toast.success('Airport was saved successfully')
      })
    },

    recreateAirportZone() {
      this.recreateZoneLoading = true
      this.api()
        .recreateZone(this.id)
        .then(result => {
          if (result.message) {
            this.$toast.success(result.message)
          }
          if (result.data && result.data.zone !== undefined) {
            this.$set(this.model, 'zone', result.data.zone)
          }
        })
        .catch(err => {
          const msg =
            err.data && err.data.message
              ? err.data.message
              : this.$t('general.error')
          this.$toast.error(msg)
        })
        .finally(() => {
          this.recreateZoneLoading = false
        })
    },
  },
}
</script>
